// src/api/dataListApi.js
import axios from './axios';

export const fetchSponsorshipTiers = async () => {
  try {
    const response = await axios.get('/master/sponsorship-tier');
    return response.data; // expected: [{ id: 1, name: 'Title Sponsor' }, ...]
  } catch (error) {
    console.error('Error fetching sponsorship tiers:', error);
    return [];
  }
};

// You can add more like this